// components/auth/LoginScreen.js
import React, { useState, useEffect } from 'react';

const LoginScreen = ({ onLogin, isDarkMode, api }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const themeStyles = {
    background: isDarkMode ? '#1a1a1a' : '#ffffff',
    color: isDarkMode ? '#ffffff' : '#000000',
    inputBg: isDarkMode ? '#2d2d2d' : '#ffffff',
    inputBorder: isDarkMode ? '#404040' : '#d1d5db',
    buttonBg: isDarkMode ? '#374151' : '#e5e7eb',
    buttonBorder: isDarkMode ? '#4b5563' : '#d1d5db',
    cardBg: isDarkMode ? '#2d2d2d' : '#f9fafb',
  };

  // Load saved credentials on component mount
  useEffect(() => {
    const savedUsername = localStorage.getItem('gtrack_username');
    const savedPassword = localStorage.getItem('gtrack_password');
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
    if (savedPassword) {
      setPassword(savedPassword);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await api.post('/auth/login', { username, password });
      
      // Save credentials if remember me is checked
      if (rememberMe) {
        localStorage.setItem('gtrack_username', username);
        localStorage.setItem('gtrack_password', password);
      } else {
        localStorage.removeItem('gtrack_username');
        localStorage.removeItem('gtrack_password');
      }

      onLogin(response.user, response.token);
    } catch (error) {
      setError('Invalid username or password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      backgroundColor: themeStyles.background,
      color: themeStyles.color,
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: themeStyles.cardBg,
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <h1 style={{ textAlign: 'center', marginBottom: '30px', color: themeStyles.color }}>
          GTrack Login
        </h1>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: themeStyles.color }}>
              Username:
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                border: `1px solid ${themeStyles.inputBorder}`,
                borderRadius: '4px',
                backgroundColor: themeStyles.inputBg,
                color: themeStyles.color,
                fontSize: '14px'
              }}
              required
              autoFocus
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: themeStyles.color }}>
              Password:
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                border: `1px solid ${themeStyles.inputBorder}`,
                borderRadius: '4px',
                backgroundColor: themeStyles.inputBg,
                color: themeStyles.color,
                fontSize: '14px'
              }}
              required
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'flex', alignItems: 'center', color: themeStyles.color }}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{ marginRight: '8px' }}
              />
              Remember my credentials
            </label>
          </div>

          {error && (
            <div style={{
              color: '#dc2626',
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: '#fee2e2',
              borderRadius: '4px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: isLoading ? '#9ca3af' : themeStyles.buttonBg,
              color: themeStyles.color,
              border: `1px solid ${themeStyles.buttonBorder}`,
              borderRadius: '4px',
              fontSize: '16px',
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;